<div>
  <mat-progress-spinner
    [diameter]="100"
    [strokeWidth]="5"
    mode="indeterminate"
  ></mat-progress-spinner>
</div>
